import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./edit-building.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./edit-building.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { SubscriberComponent } from "../../../../../shared/components/subscriber/subscriber.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppControllerService } from "../../../../../app-controller.service";
import { AlertType } from "../../../../../shared/models/alert";
import { CreateApplicationLocationBpamsConstants } from "../create-application-location-bpams.constants";
export let EditBuildingComponent = class EditBuildingComponent extends SubscriberComponent {
    activeModal;
    appController;
    modalTitle;
    building;
    editedIndex;
    editForm;
    cancelLabel = SharedConstants.CANCEL_LABEL;
    createLabel = SharedConstants.UPDATE_LABEL;
    validationMessages = CreateApplicationLocationBpamsConstants.VALIDATION_MESSAGES;
    floorLabel = CreateApplicationLocationBpamsConstants.FLOOR_LABEL;
    existingSizeLabel = CreateApplicationLocationBpamsConstants.EXISTING_SIZE_LABEL;
    addedSizeLabel = CreateApplicationLocationBpamsConstants.ADDED_SIZE_LABEL;
    floorControlName = CreateApplicationLocationBpamsConstants.FLOOR_CONTROL_NAME;
    existingSizeControlName = CreateApplicationLocationBpamsConstants.EXISTING_SIZE_CONTROL_NAME;
    addedSizeControlName = CreateApplicationLocationBpamsConstants.ADDED_SIZE_CONTROL_NAME;
    constructor(activeModal, appController) {
        super();
        this.activeModal = activeModal;
        this.appController = appController;
    }
    ngOnInit() {
        this.editForm = new FormGroup({
            floor: new FormControl(this.building.floor, [Validators.required]),
            existingSize: new FormControl(this.building.existingSize, [Validators.required]),
            addedSize: new FormControl(this.building.addedSize, [Validators.required])
        });
    }
    onBtnSaveClicked($event) {
        if (this.editForm.valid) {
            this.building.floor = this.editForm.get(this.floorControlName).value;
            this.building.existingSize = this.editForm.get(this.existingSizeControlName).value;
            this.building.addedSize = this.editForm.get(this.addedSizeControlName).value;
            this.activeModal.close([this.editedIndex, this.building]);
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    onBtnCancelClicked($event) {
        this.activeModal.close(null);
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: AppControllerService }
    ];
    static propDecorators = {
        modalTitle: [{ type: Input }],
        building: [{ type: Input }],
        editedIndex: [{ type: Input }]
    };
};
EditBuildingComponent = __decorate([
    Component({
        selector: "app-edit-building",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], EditBuildingComponent);
